import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailVerificationPageService {

  constructor(private http: HttpClient) { }

  getemailVerificationPageService(emailval){
  
    console.log(emailval);
    var temp = this.http.get<any>(`${environment.apiUrl}/auth/verifyEmail/`+ emailval);

    return temp;
}
}
